import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectEditingAsset } from "../../app/slices/AssetsSlice";
import PiBrowseDialog from "../../components/PiBrowseDialog";
import { DialogProps } from "../../components/PiDialog";
import LocalizeFileBody from "../variants/LocalizeFileBody";

type EditAssetDialogProps = DialogProps;

/**
 * The localize dialog, on the shared browse shell. It does one job now —
 * managing a file's localizations. Renaming moved out to the file itself
 * (see `AssetRowMenu`), which is why the name here is a badge rather than a
 * field, and why the footer has a single primary action.
 */
export default function EditAssetDialog(props: EditAssetDialogProps) {
  const { t } = useTranslation();
  const editingAsset = useSelector(selectEditingAsset);

  const scopeBadge = editingAsset ? (
    <span className="px-[10px] py-[3px] rounded-full border border-creator-primary bg-creator-primary-washed text-[11px] leading-[14px] font-medium text-creator-text-key max-w-[320px] truncate">
      {editingAsset.name}
    </span>
  ) : undefined;

  return (
    <PiBrowseDialog
      open={props.open}
      onClose={props.onClose}
      title={t("localize_file")}
      scopeBadge={scopeBadge}
      body={<LocalizeFileBody onClose={props.onClose} />}
    />
  );
}
